module.exports = __webpack_public_path__ + "img/插图_加入我们_04@2x.6ae04787.png";